<template>
	<div class="star">
		<span class="star-item" v-for="(item, index) in starList" :key="index" :class="item"></span>
	</div>
</template>
<script>
	export default {
		props:{
			scores:Number
		},
		data() {
			return {
				score: this.scores
			}
		},
		created(){
		},
		mounted() {
			// this.score = this.scores/2
			// console.log(this.scores)
		},
		computed: {
			starList: function() {
				let result = []
				let scores = localStorage.getItem("score")/2
				const score = Math.floor(scores * 2) / 2 // 4.7 -> 4.5    4.2 -> 4
				console.log(score)
				const integer = Math.floor(score)
				const hasDecimal = score % 1 !== 0
				// 先将on添加到list中
				for (let i = 0; i < integer; i++) {
					result.push('on')
				}
				// 将半选添加到list
				if (hasDecimal) result.push('half')
				// 若不满5个，剩下的添加off直到满5个为止
				for (let i = result.length; i < 5; i++) {
					result.push('off')
				}
				return result
			}
		}
	}
</script>
<style lang="less" scoped>
	.star-item {
		display: inline-block;
		width: 20px;
		height: 20px;
		background-size: 100%;
		margin-right: 2px;
		&.on {
			background-image: url('../assets/star-on.jpg');
		}

		&.off {
			background-image: url('../assets/star-offf.jpg');
		}

		&.half {
			background-image: url('../assets/star-half.jpg');
		}
	}
</style>
